<template lang="pug">
div
  div

  v-subheader {{ data.name }}
  v-btn(text, block, @click="checkFlow") check flow
  v-dialog(v-model="stepDialog", max-width="800")
    template(v-slot:activator="{ on }")
      v-btn(block, v-on="on", color="primary") add step
    v-card
      v-card-title
        span.headline {{ formTitle }}
      v-card-text
        v-container
          v-row
            v-col(md="12")
              v-autocomplete(
                v-model="editedItem.question_id",
                label="Answer type",
                :items="questions",
                item-text="title",
                item-value="ID",
                outlined,
                hide-details,
                :disabled="editedIndex != -1"
              )
            v-col(md="12")
              v-text-field(
                v-model="editedItem.condition",
                label="Condition",
                outlined,
                hint="Condition to show this step. It has only IF condition for now. IF(\"employee\".\"title\" == \"Mr.\")",
                persistent-hint
              )
            v-col(md="12")
              v-checkbox(v-model="editedItem.skip_step", label="Skip step")
            //- v-col(md='12' v-if='')
            //-   div(v-for='(value, i) in editedItem.value_conditions' :key='i')
            //-     v-row(align='end')
            //-       v-col(md='2')
            //-         span {{value.answer_value.label}}
            //-       v-col(md='3')
            //-         v-checkbox(label='Go next' hint='Go next question after input' persistent-hint v-model='value.go_next')
            //-       v-col(md='6')
            //-         v-text-field(v-if='!value.go_next' hide-details label='Rule' v-model='value.rule')
          v-row
            codemirror.editor(
              v-model="editedItem.rule",
              :options="cmOptions",
              ref="editor"
            )
      v-card-actions
        v-spacer
        v-btn(text, color="primary", @click="close") Cancel
        v-btn(text, color="primary", @click="save") Save
  .pa-4(ref="group")
    draggable(v-model="steps")
      transition-group
        .item.d-flex.align-center.pa-2(
          v-for="step in steps",
          :key="step.ID + ' ' + step.index"
        )
          .handle.mr-2 ::
          .mr-2 {{ step.index }}.
          v-chip.mr-2 {{ step.question.category }}
          v-tooltip(bottom, v-if="step.condition_check")
            template(v-slot:activator="{ on, attrs }")
              v-chip.mr-2(color="error", v-bind="attrs", v-on="on") ERROR
            span {{ step.condition_check }}
          v-tooltip(bottom, v-else-if="step.condition")
            template(v-slot:activator="{ on, attrs }")
              v-chip.mr-2(color="yellow", v-bind="attrs", v-on="on") Has condition
            span {{ step.condition }}
          span {{ step.question.title.length > 120 ? step.question.title.substring(0, 117) + '...' : step.question.title }}
          v-spacer
          v-btn.btn(icon, @click="deleteStep(step.ID)")
            v-icon mdi-delete
          v-btn.btn(icon, @click="editItem(step)")
            v-icon mdi-pencil
</template>

<script>
import draggable from "vuedraggable";
import "codemirror/mode/lua/lua.js";
export default {
  components: { draggable },
  props: ["data", "questions"],
  data() {
    return {
      stepDialog: false,
      editedIndex: -1,
      cmOptions: {
        tabSize: 4,
        mode: "text/x-lua",
        line: true,
        lineNumbers: true,
      },
      editedItem: {
        question_id: null,
        condition: "",
        rule: "",
        skip_step: false,
        question: {
          answer_blocks: [],
        },
        // value_conditions: []
      },
      defaultItem: {
        question_id: null,
        condition: "",
        rule: "",
        skip_step: false,
        question: {
          answer_blocks: [],
        },
        // value_conditions: []
      },
    };
  },
  watch: {
    stepDialog(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.editor.codemirror.refresh();
        }, 300);
      }
      val || this.close();
    },
  },
  methods: {
    checkFlow() {
      this.$emit("checkFlow", this.data.ID);
    },
    deleteStep(id) {
      this.axios.delete(`/admin/flow/${this.data.ID}/steps?step_id=${id}`).then(() => {
        this.$emit("refresh");
      });
    },
    editItem(item) {
      this.editedIndex = this.data.steps.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.stepDialog = true;
    },
    close() {
      this.stepDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.editedIndex === -1
        ? this.$emit("add", this.data.ID, this.editedItem)
        : this.$emit("save", this.data.ID, this.editedItem);
      this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New step" : "Edit step";
    },
    steps: {
      get() {
        return this.data.steps;
      },
      set(value) {
        this.$emit("changeOrder", value, this.data.ID);
      },
    },
  },
  mounted() {
    // const table = this.$refs.group
    // Sortable.create(table, {
    //   handle: '.handle',
    //   onChange: (evt) => {
    //
    //   },
    // })
  },
};
</script>

<style lang="sass" scoped>
.editor
  width: 500px
  height: 400px
.item
  height: 48px
  transition: background-color .3s
  .btn
    display: none
  .status
    width: 10px
    height: 10px
    border-radius: 50%
    background-color: red
  &:hover
    background-color: #E5E5E5
    .btn
      display: block
  .handle
    cursor: move
</style>